class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        this.observeDOMChanges();
        this.handleIntersects();
        this.interceptCartApi();
        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on("click", '[data-action="add-item"]', this.sendAddToCart.bind(this));
        //this.delegateBody.on("click", '[data-action="remove-item"]', this.removeFromCart.bind(this));
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/json"],script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

                console.log(entry, "observed");

                if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                console.log(data, "And pushed to dataLayer");
            }
        });
    }

    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;

        window.fetch = async function (...args) {
            try {
                const [url] = args;

                // Trigger custom logic for cart clear API
                if (url.includes(`/cart/clear.js`)) _this.cartClear();
                const response = await originalFetch.apply(this, args);

                // Early return for non-cart-related APIs or missing conditions
                if (url === '' || !dataLayer || 
                    !url.includes(`/cart/add.js`) || 
                    !url.includes(`/cart/change.js`) || 
                    !url.includes(`/cart/update.js`)
                ) return response;

                // Clone response to safely process its JSON
                const responseClone = structuredClone(response);
                const json = responseClone.json();

                if (!response.ok) return response;

                // Process cart actions based on URL
                if (url.includes(`/cart/add.js`)) {
                    _this.cartAdd(json);

                } else if (url.includes(`/cart/change.js`) || url.includes(`/cart/update.js`)) {
                    _this.cartUpdate(json);
                }

                return response;

            } catch (e) {
                console.error('Fetch interceptor error:', error);
                return originalFetch(...args);
            }
        };
    }

    async cartAdd(cart) {
        cart.items ? this.productAdded(cart.items) : this.productAdded([cart]);
        this.productAdded(cart.items)
    }

    async cartUpdate(cart) {
        this.productAdded(cart.items_added);
        this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    productAdded(cartItems) {
        if (!cartItems.length) return;

        const items = [];
        let totalPrice = 0;

        cartItems.forEach(item => {
            const price = Shopify.formatMoney(item.price, '{{amount}}');
            totalPrice += price;

            items.push({
                'item_id': item.sku,
                'item_variant': item.variant_title,
                'item_name': item.product_title,
                'price': price,
                'quantity': item.quantity
            })
        })

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            'event': 'add_to_cart_custom',
            'ecommerce': {
                'value': parseInt(totalPrice),
                'items': items
            }
        });

        console.log("dataLayer push -> added:", items);
    }

    async productsRemoved(cartItems) {
        if (!cartItems.length) return;

        const items = [];
        let totalPrice = 0;

        cartItems.forEach(item => {
            const price = Shopify.formatMoney(item.price, '{{amount}}');
            totalPrice += price;

            items.push({
                'item_id': item.sku,
                'item_variant': item.variant_title,
                'item_name': item.product_title,
                'price': price,
                'quantity': item.quantity
            })
        })

        dataLayer.push({
            event: "remove_from_cart",
            remove: {
                value: totalPrice,
                items: items
            },
        });

        console.log("dataLayer push -> removed:", items);
    }

    sendAddToCart(event) {
        
        setTimeout(() => {
            let target = document.querySelector('.cart__item');
            console.log(target);

            const settings = JSON.parse(target.closest("[data-added]").dataset.added);
        
            if (!dataLayer || !settings) return;
        
            dataLayer.push({
            event: "add_to_cart_custom",
            added: {
                value: settings.value, // The total value of the items being removed.
                items: [
                {
                    item_id: settings.item_id, // ID of the product
                    item_name: settings.item_name, // Name of the product
                    price: settings.price, // Price of the product
                    quantity: settings.quantity, // Number of items removed
                },
                ],
            },
            });
            console.log(dataLayer)
        }, 2000);

        // let items = document.querySelectorAll('.cart__item');
      
        // if (dataLayer) {
        //   dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
      
        //   let ecommerceData = {
        //     'event': 'add_to_cart_custom',
        //     'ecommerce': {
        //       'value': 0, // We'll calculate the total value below
        //       'items': []
        //     }
        //   };
      
        //   // Loop through each item in the array and add it to the ecommerce data
        //   items.forEach((item) => {
        //     const sku = item.getAttribute('data-sku');
        //     const productName = item.getAttribute('data-item-title'); 
        //     const price = parseInt(item.getAttribute('data-price') / 100); 
        //     const quantity = parseInt(item.getAttribute('data-quantity')); 
        //     const variantTitle = item.getAttribute('data-variant-title');
        //     // const price = parseInt(item.price / 100);
        //     // const quantity = parseInt(item.quantity);
            
        //     // Add each item's details
        //     ecommerceData.ecommerce.items.push({
        //       'item_id': sku,
        //       'item_variant': variantTitle,
        //       'item_name': productName,
        //       'price': price,
        //       'quantity': quantity
        //     });
      
        //     // Update the total value
        //     ecommerceData.ecommerce.value += price * quantity;
        //   });
      
        //   // Push the data to the dataLayer
        //   dataLayer.push(ecommerceData);
        //   console.log(ecommerceData)
        // }
    }

    removeFromCart(event) {
        let target = event.target;
    
        const settings = JSON.parse(target.closest("[data-remove]").dataset.remove);
    
        if (!dataLayer || !settings) return;
    
        dataLayer.push({
          event: "remove_from_cart",
          remove: {
            value: settings.value, // The total value of the items being removed.
            items: [
              {
                item_id: settings.item_id, // ID of the product
                item_name: settings.item_name, // Name of the product
                price: settings.price, // Price of the product
                quantity: settings.quantity, // Number of items removed
              },
            ],
          },
        });
        console.log(dataLayer)
    }
}

new gTagEvents();